import { render, staticRenderFns } from "./ComiteCientifico.vue?vue&type=template&id=31a856f9&"
import script from "./ComiteCientifico.vue?vue&type=script&lang=js&"
export * from "./ComiteCientifico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports